<template>
  <div class="full">
    <div class="bg full">
      <el-form ref="form" :model="form" label-width="80px" class="flex">
        <el-form-item label="手机号码:" class="item">
          <el-input v-model="form.phoneno" id="phoneno" type="number"></el-input>
        </el-form-item>
        <el-form-item label="设备密码:" class="item">
          <el-input v-model="form.devicepwd"></el-input>
        </el-form-item>
        <div class="center" style="text-align:center;">
          <el-button type="primary" @click="submit(form)">立即登陆</el-button>
        </div>
      </el-form>
    </div>
  </div>
</template>
<script>
import axios from 'axios';
import FingerprintJS from '@fingerprintjs/fingerprintjs';
export default {
  data() {
    return {
      form: {
        phoneno: "",
        imei: "",
        devicepwd:"",
      },
    };
  },
  methods: {
    async onload(){
      const fp = await FingerprintJS.load();

      // The FingerprintJS agent is ready.
      // Get a visitor identifier when you'd like to.
      const result = await fp.get();
    
      // This is the visitor identifier:
      this.form.imei = result.visitorId;
      //console.log(this.form.imei);
    },
    async getDeviceNum(params) {
      const res = await axios
        .get("http://gameserver.9help.net/ManageCenter/DeviceBind", {
          params
        })
        .catch(function (err) {
          console.log(err);
        });
        const {data} = res;
        if(data.code == 0){
          this.$router.push({ path: "/" });
        }
        else{
          alert('绑定失败，请联系客服');
        }
    },
    submit(params){
      var phoneno = document.getElementById('phoneno').value;
      if(phoneno==null || phoneno=="" || phoneno==undefined ||phoneno.length!=11)
      {
        alert('请您输入正确的电话号码');
      }
      else{
        this.getDeviceNum(params);
      }
    }
  },
  mounted(){
    this.onload();
  }
};
</script>